<template>
  <div>
    <v-card elevation="1" class="pa-8">
      <v-row>
        <v-col cols="12" class="text-center">
          <template v-if="project_type == 3">
            <h2 class="page-title pb-5" v-if="consider_type == 'technic'">
              ผลการพิจารณาคุณสมบัติและคำเสนอขอขายไฟฟ้าด้านเทคนิค
            </h2>
            <h2 class="page-title pb-5" v-else>
              ผลการพิจารณาคุณสมบัติและคำเสนอขอขายไฟฟ้าด้านราคา
            </h2>
          </template>
          <template v-else-if="project_type == 4">
            <h2 class="page-title pb-5">
              ผลการพิจารณาคุณสมบัติและคำเสนอขอขายไฟฟ้าสำหรับ
            </h2>
          </template>
          <p>{{ project_title }}</p>
          <p v-if="requests.length != 0">
            จำนวนทั้งหมด {{ requests.length }} คำเสนอ
          </p>
          <div v-html="announce_header"></div>
        </v-col>
      </v-row>
      <v-row v-if="requests.length != 0" id="sectionDataTable">
        <v-col cols="12">
          <v-data-table
            v-if="project_type == 3"
            :headers="headers"
            :items="requests"
            mobile-breakpoint="0"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.notification_no="{ item }">
              <span class="text-no-wrap">
                {{ item.notification_no }}
              </span>
            </template>
            <template v-slot:item.is_pass="{ item }">
              <span
                :class="[
                  item.is_pass == true
                    ? 'light-green--text text--darken-2'
                    : 'red--text'
                ]"
              >
                {{ item.is_pass == true ? "ผ่าน" : "ไม่ผ่าน" }}
              </span>
            </template>
          </v-data-table>
          <v-simple-table
            v-else-if="project_type == 4"
            id="emergency-table"
            dense
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    เลขที่คำเสนอขอขายไฟฟ้า
                  </th>
                  <th style="max-width:150px;">
                    ชื่อผู้ยื่นขอผลิดไฟฟ้าขนาดเล็กมาก
                  </th>
                  <th>จังหวัด</th>
                  <th>ระดับแรงดันเชื่อมต่อ</th>
                  <th>จุดเชื่อมต่อ</th>
                  <th>ประเภทเชื้อเพลิง</th>
                  <th style="max-width:200px;">ปริมาณพลังไฟฟ้าเสนอขาย (MW)</th>
                  <th style="max-width:240px;">
                    ปริมาณพลังไฟฟ้าที่ กฟภ. รับซื้อในครั้งนี้ (MW)
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="request in requests">
                  <tr :key="request.notification_no">
                    <td
                      class="text-center"
                      :rowspan="request.pea_receive_topup_electric.length + 1"
                    >
                      {{ request.notification_no }}
                    </td>
                    <td
                      :rowspan="request.pea_receive_topup_electric.length + 1"
                    >
                      {{ request.business_partner_name }}
                    </td>
                    <td
                      class="text-center"
                      :rowspan="request.pea_receive_topup_electric.length + 1"
                    >
                      {{ request.province.substr(2) }}
                    </td>
                    <td
                      class="text-center"
                      :rowspan="request.pea_receive_topup_electric.length + 1"
                    >
                      {{ request.voltage_level_connection }}
                    </td>
                    <td
                      :rowspan="request.pea_receive_topup_electric.length + 1"
                    >
                      {{ request.connection_location }}
                    </td>
                  </tr>
                  <tr
                    v-for="(item, index) in request.pea_receive_topup_electric"
                    :key="`${request.notification_no}_${index}`"
                  >
                    <template>
                      <td
                        :class="[
                          item.energy_sub_type == 1 ? 'pl-8' : '',
                          'text-no-wrap'
                        ]"
                      >
                        {{ energy_text(item) }}
                      </td>
                      <td class="text-center">
                        {{ item.vspp_offer_electric || "" }}
                      </td>
                      <td class="text-center">
                        {{ pea_receive_electric_text(item) }}
                      </td>
                    </template>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row v-if="announce_document.length != 0" id="sectionDataTable">
        <v-col class="pt-0">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">ชื่อเอกสาร</th>
                  <th class="text-center" width="20%">ดาวน์โหลด</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="document in announce_document"
                  :key="document.document_title"
                >
                  <td>
                    <v-icon left>far fa-file-pdf</v-icon
                    >{{ document.document_title }}
                  </td>
                  <td class="text-center">
                    <v-btn
                      color="purple lighten-2"
                      elevation="0"
                      fab
                      dark
                      small
                      rel="noopener noreferrer"
                      target="_blank"
                      :href="'/api/v1/data/file/' + document.file"
                    >
                      <v-icon small>fas fa-cloud-download-alt</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-html="announce_footer"></v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { DateTime } from "@/plugins/app";
import api from "@/plugins/axios";
export default {
  data: () => ({
    project_code: null,
    project_title: null,
    project_type: null,
    table_index: 1,
    requests: [],
    announce_document: [],
    headers: [
      {
        text: "เลขที่คำเสนอขอขายไฟฟ้า",
        value: "notification_no",
        align: "center",
        sortable: false,
        width: "25%"
      },
      {
        text: "สถานะ",
        value: "is_pass",
        align: "center",
        sortable: false,
        width: "25%"
      } /*,
      {
        text: "หมายเหตุ",
        value: "note",
        align: "center",
        sortable: false
      }*/
    ],
    announce_header: null,
    announce_footer: null,
    temp_energy_parent_text: null
  }),
  methods: {
    getDate(date_announce) {
      return DateTime.fromISO(date_announce)
        .setLocale("th-TH")
        .toLocaleString({ day: "numeric", month: "short", year: "numeric" });
    },
    energy_text(energy) {
      return energy.energy_sub_type == 1
        ? `- ${energy.energy_type_text}`
        : energy.energy_type_text;
    },
    pea_receive_electric_text(energy) {
      if (energy.energy_sub_type == 0 && energy.vspp_offer_electric == 0)
        return "";
      else if (energy.pea_receive_electric == 0) return "-";
      else return energy.pea_receive_electric;
    }
    /*getAnnounceHeader(){
      if(this.consider_type == "price"){
        return  [
                  {
                    text: "เลขที่คำเสนอขอขายไฟฟ้า",
                    value: "notification_no",
                    align: "center",
                    sortable: false,
                    width: "25%"
                  },
                  { 
                    text: "สถานะ", 
                    value: "is_pass", 
                    align: "center", 
                    sortable: false,
                    width: "25%"
                  }
                ]
      }else{
        return this.headers
      }
    }*/
  },
  computed: {},
  created() {
    let pid = this.$route.params.pid;
    let consider_type = this.$route.params.consider_type;
    this.project_code = pid;
    this.consider_type = consider_type;

    api
      .get("/project/eco/announce/" + consider_type + "/" + pid)
      .then(response => {
        this.requests = response.data.request;
        this.project_type = response.data.project_type;
        this.project_title = response.data.project_title;
        this.project_code = response.data.project_code;
        this.announce_document = response.data.announce_document;
        this.announce_header = response.data.announce_header;
        this.announce_footer = response.data.announce_footer;
      });
  }
};
</script>

<style scoped>
#emergency-table th {
  vertical-align: top;
  white-space: normal;
  text-align: center;
}
#emergency-table tr:last-child > td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
</style>
